<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="600px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row dense> 
                <v-text-field counter="50" :rules="[ v => (v.length <= 50) || $t('eventmap_label1') ]" 
                  v-model="editedItem.TITLE" :label="$t('eventmap_label2')"
                  outlined
                  />
              </v-row>
              <v-row>
                <v-img
                  ref="prewviwe_image"
                  :src="editedItem.IMAGE"
                  height="100" contain aspect-ratio="1"
                  >
                </v-img>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-file-input accept="image/*" :label="$t('eventmap_label3')" v-model="uploadFile" @change="changefile" ></v-file-input>
                </v-col>
              </v-row>
              <v-row dense> 
                <v-textarea counter="1000" outlined v-model="editedItem.DESC" :label="$t('eventmap_col3')" :rules="[ v => (v.length <= 1000) || $t('eventmap_label4') ]"></v-textarea>
              </v-row>
              <v-row dense> 
                <v-text-field counter="100" v-model="editedItem.LINK" :label="$t('eventmap_col4')" :rules="[ v => (v.length <= 100) || $t('eventmap_label5') ]"></v-text-field>
              </v-row>
              <!-- 
              <v-row dense> 
                <v-text-field outlined v-model="editedItem.SORT" label="표시 순서"></v-text-field>
              </v-row>
              -->
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense align="center">
      <v-col cols="12" md="2" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>
      <template v-if="grade >= 50">
        <v-col md="3" sm="12" xs="12" class="pa-0">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
        <eventdialog   :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="4" md="1" sm="4" xs="4" class="pa-0" align="center">
        <v-btn width="94%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>        
      <v-col cols="4" md="1" sm="4" xs="4" class="pa-0" align="center">
        <v-btn width="94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>        
      <v-col cols="4" md="1" sm="4" xs="4" class="pa-0" align="center">
        <v-btn width="94%" class="yellow_btn_freesize" elevation="0" outlined large @click="saveSort">{{$t('eventmap_label6')}}</v-btn>        
      </v-col>
    </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <draggable v-model="items">
        <v-data-table
          :headers="headers"
          :items="items"
          :no-data-text="$t('common_nodata')"
          hide-default-footer
          class="datatablestyle"
          item-key="IDX"
          :loading="loading"
          :items-per-page="9999"
          >    

          <template v-slot:header.TITLE>
            <label class="cheader_normal" >{{$t("eventmap_col1")}}</label>
          </template>
          <template v-slot:header.IMAGE>
            <label class="cheader_normal" >{{$t("eventmap_col2")}}</label>
          </template>
          <template v-slot:header.DESC>
            <label class="cheader_normal" >{{$t("eventmap_col3")}}</label>
          </template>
          <template v-slot:header.LINK>
            <label class="cheader_normal" >{{$t("eventmap_col4")}}</label>
          </template>
          <template v-slot:header.actions>
            <label class="cheader_normal" >{{$t("eventmap_col5")}}</label>
          </template>
                                                  

          <template v-slot:body="props">
            <draggable :list="props.items" ghost-class="ghost" @change="changedrag" tag="tbody">
              <tr v-for="(item, index) in props.items" :key="index">
                <td style="width:50px; text-align:center"><v-icon small>mdi-drag</v-icon></td>
                <td style="width:100px; text-align:center">{{ item.TITLE }}</td>
                <td style="width:200px; text-align:center"><v-row><v-img :src="item.IMAGE" height="80" width="200" contain/></v-row></td>
                <td style="width:200px; text-align:center"><label> {{ item.DESC.length > 20 ? item.DESC.substring(0,20)+"..." : item.DESC }} </label></td>
                <td style="width:80px; text-align:center">{{ item.LINK }}</td>
                <!-- <td style="width:80px; text-align:center">{{ item.SORT }}</td> -->
                <td style="width:80px; text-align:center"><v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon><v-icon small @click="delete_item(item)">mdi-delete</v-icon></td>
              </tr>
            </draggable>
          </template>
        </v-data-table>
      </draggable>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import draggable from 'vuedraggable'

export default {

    components: {
            draggable,
    },

    data: () => ({

      //파일 업로드
      uploadFile : null,

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          TITLE:'',
          IMAGE:'',
          DESC:'',
          LINK:'',
          SORT:'',
      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '', value: '', sortable: false, align:'center', width:'50px'},
        {text: '제목', value: 'TITLE', sortable: true, align:'center' },
        {text: '이미지', value: 'IMAGE', sortable: true, align:'center'},
        {text: '설명', value: 'DESC', sortable: true, align:'center'},
        {text: '링크', value: 'LINK', sortable: true, align:'center'},
        //{text: '표시순서', value: 'SORT', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      items: [],
      
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      
      grade : 0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");
      
      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      saveSort(){

        if(this.items.length <= 1){
          this.$alert(this.$t('eventmap_msg1'));
          return;
        }

        //드래그앤드랍 순서를 저장한다.
        this.$confirm(this.$t('eventmap_msg2'))
        
        .then(() => {

          var tempidx = 1;
          this.items.forEach(item=>{
            item.SORT = tempidx;
            tempidx++;
          });

          this.loading = true;
          this.$http.post(this.$host+'/api/EventMapUpdateSort',
            {
              SORTDATA: escape(JSON.stringify(this.items))
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('eventmap_msg3')).then(()=>{
                  this.loadpage();
                });
  

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t('common_sort_fail'));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t('common_sort_fail'));
          });

        });
      },      

      //오리지널 리스트 순서를 변경
      changedrag(e){
        this.items.splice(e.moved.oldIndex, 1);  //원본 위치에서 제거
        this.items.splice(e.moved.newIndex, 0, e.moved.element);  //새로운 위치에 다시 추가
      },

      loadpage(){
          
          this.items.splice(0, this.items.length);   //데이터 초기화
          
          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;

          this.$http.post(this.$host+'/api/EventMapList',{
                COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                const list = result.data.resultData;
                
                list.forEach(element => {
                    this.items.push(element); 
                });

                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.TITLE  == undefined || this.editedItem.TITLE.length < 1){
          this.$alert(this.$t('eventmap_msg4'));
          return;
        } 
        if(this.editedItem.TITLE.length > 50){
          this.$alert(this.$t('eventmap_msg5'));
          return;
        } 

        if(this.editedItem.DESC.length > 1000){
          this.$alert(this.$t('eventmap_msg6'));
          return;
        } 

        if(this.editedItem.LINK.length > 100){
          this.$alert(this.$t('eventmap_msg7'));
          return;
        } 

        if(this.editedItem.SORT == undefined || this.editedItem.SORT.length < 1){
          this.$alert(this.$t('eventmap_msg8'));
          return;
        } 

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;

          const formData = new FormData();
          formData.append("FOLDER",  this.SEARCH_COM_IDX+"/eventmap");
          formData.append("IDX",     this.editedItem.IDX);
          formData.append("COM_IDX", this.SEARCH_COM_IDX);
          formData.append("TITLE", this.editedItem.TITLE);
          formData.append("DESC", this.editedItem.DESC);
          formData.append("LINK", this.editedItem.LINK);
          formData.append("SORT", this.editedItem.SORT);
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/EventMapUpdate', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            this.loading = false;
            this.uploadFile = null;
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{

          //신규
          this.loading = true;
          const formData = new FormData();
          formData.append("FOLDER",  this.SEARCH_COM_IDX+"/eventmap");
          formData.append("COM_IDX", this.SEARCH_COM_IDX);
          formData.append("EVENT_IDX", this.SEARCH_EVENT_IDX);
          formData.append("TITLE", this.editedItem.TITLE);
          formData.append("DESC", this.editedItem.DESC);
          formData.append("LINK", this.editedItem.LINK);
          formData.append("SORT", this.editedItem.SORT);
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/EventMapInsert', formData, {
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            this.loading = false;
            this.uploadFile = null;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t('common_insert_msg')).then(()=>{
                this.loadpage();
              });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }

        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME
        this.editedItem.SORT        = this.items.length+1;
        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.items.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventMapDelete',{
              IDX:item.IDX
            , COM_IDX: this.SEARCH_COM_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },


      //행사날자 선택 콜백
      select_scheduledate(var1){
        this.editedItem.SCHEDULE_DATE = var1;
      },

      select_starttime(var1){
        this.editedItem.START_TIME = var1;
      },

      select_endtime(var1){
        this.editedItem.END_TIME = var1;
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.items.splice(0, this.items.length);   //데이터 초기화
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.items.splice(0, this.items.length);   //데이터 초기화
      },



      changefile(){
      },


    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>